import * as yup from "yup";

export const updateWasteCombustionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  wasteType: yup.string().required("Waste type is required"),
  wasteDisposalOption: yup
    .string()
    .required("Waste disposal option is required"),
  unit: yup.string().required("Fuel unit is required"),
  amount: yup
    .number()
    .typeError("Amount of fuel must be a valid number")
    .required("Amount of fuel is required"),
});
